export const mockWeatherData = {
    locationId: '066fd6b3-803d-4ac8-9d1e-233da047d913',
    locationName: 'Portrush',
    latitude: '55.2051105',
    longitude: '-6.6546737',
    currentDailyForecast: {
        dateTime: '2025-07-07T00:00Z',
        dateTimeText: 'Mon',
        maxTemperature: '16',
        minTemperature: '13',
        weatherCode: '12',
        probabilityOfPrecipitation: '53',
        windSpeed: '10.07',
        windSpeedMph: '22.5',
        windDirection: '305',
        windDisplayDirection: 'NW'
    },
    currentHourlyForecast: {
        dateTime: '2025-07-07T09:00Z',
        dateTimeText: '10am',
        maxTemperature: '15',
        minTemperature: '14',
        weatherCode: '7',
        probabilityOfPrecipitation: '9',
        windSpeed: '11.42',
        windSpeedMph: '25.5',
        windDirection: '317',
        windDisplayDirection: 'NW',
        totalPrecipitationAmount: '0.0'
    },
    hourly: [
        {
            dateTime: '2025-07-07T09:00Z',
            dateTimeText: '10am',
            maxTemperature: '15',
            minTemperature: '14',
            weatherCode: '7',
            probabilityOfPrecipitation: '9',
            windSpeed: '11.42',
            windSpeedMph: '25.5',
            windDirection: '317',
            windDisplayDirection: 'NW',
            totalPrecipitationAmount: '0.0'
        },
        {
            dateTime: '2025-07-07T12:00Z',
            dateTimeText: '1pm',
            maxTemperature: '15',
            minTemperature: '15',
            weatherCode: '7',
            probabilityOfPrecipitation: '30',
            windSpeed: '10.07',
            windSpeedMph: '22.5',
            windDirection: '305',
            windDisplayDirection: 'NW',
            totalPrecipitationAmount: '0.0'
        },
        {
            dateTime: '2025-07-07T15:00Z',
            dateTimeText: '4pm',
            maxTemperature: '15',
            minTemperature: '14',
            weatherCode: '12',
            probabilityOfPrecipitation: '53',
            windSpeed: '10.84',
            windSpeedMph: '24.2',
            windDirection: '304',
            windDisplayDirection: 'NW',
            totalPrecipitationAmount: '0.22'
        },
        {
            dateTime: '2025-07-07T18:00Z',
            dateTimeText: '7pm',
            maxTemperature: '14',
            minTemperature: '14',
            weatherCode: '12',
            probabilityOfPrecipitation: '50',
            windSpeed: '10.19',
            windSpeedMph: '22.8',
            windDirection: '309',
            windDisplayDirection: 'NW',
            totalPrecipitationAmount: '0.16'
        },
        {
            dateTime: '2025-07-07T21:00Z',
            dateTimeText: '10pm',
            maxTemperature: '14',
            minTemperature: '14',
            weatherCode: '7',
            probabilityOfPrecipitation: '13',
            windSpeed: '8.13',
            windSpeedMph: '18.2',
            windDirection: '314',
            windDisplayDirection: 'NW',
            totalPrecipitationAmount: '0.0'
        }
    ],
    daily: [
        {
            dateTime: '2025-07-07T00:00Z',
            dateTimeText: 'Mon',
            maxTemperature: '16',
            minTemperature: '13',
            weatherCode: '12',
            probabilityOfPrecipitation: '53',
            windSpeed: '10.07',
            windSpeedMph: '22.5',
            windDirection: '305',
            windDisplayDirection: 'NW'
        },
        {
            dateTime: '2025-07-08T00:00Z',
            dateTimeText: 'Tue',
            maxTemperature: '18',
            minTemperature: '14',
            weatherCode: '7',
            probabilityOfPrecipitation: '41',
            windSpeed: '2.37',
            windSpeedMph: '5.3',
            windDirection: '321',
            windDisplayDirection: 'NW'
        },
        {
            dateTime: '2025-07-09T00:00Z',
            dateTimeText: 'Wed',
            maxTemperature: '20',
            minTemperature: '13',
            weatherCode: '7',
            probabilityOfPrecipitation: '52',
            windSpeed: '4.24',
            windSpeedMph: '9.5',
            windDirection: '261',
            windDisplayDirection: 'W'
        },
        {
            dateTime: '2025-07-10T00:00Z',
            dateTimeText: 'Thu',
            maxTemperature: '22',
            minTemperature: '14',
            weatherCode: '7',
            probabilityOfPrecipitation: '8',
            windSpeed: '4.06',
            windSpeedMph: '9.1',
            windDirection: '227',
            windDisplayDirection: 'SW'
        },
        {
            dateTime: '2025-07-11T00:00Z',
            dateTimeText: 'Fri',
            maxTemperature: '25',
            minTemperature: '15',
            weatherCode: '1',
            probabilityOfPrecipitation: '3',
            windSpeed: '5.47',
            windSpeedMph: '12.2',
            windDirection: '181',
            windDisplayDirection: 'S'
        }
    ]
};
